import { PT } from '../data/mockData';

export default function ProgTypeTag({ type, small }) {
  const t = PT[type];
  if (!t) return null;
  return (
    <span className={`pt ${t.cls}`}>
      <i className={`fa-solid ${t.icon}`} style={{ fontSize: small ? '.6rem' : '.65rem' }} /> {t.label}
    </span>
  );
}
